<template>
  <div class="dropdown-wrapper" ref="dropdown">
    <button class="dropdown-button" @click="toggleMenu">
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
    </button>
    <!-- Dropdown Menu -->
    <div class="dropdown-menu" v-if="showMenu">
      <button class="menu-item" @click="handleShareProfile(toShare,'','',this)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="18" cy="5" r="3"/>
          <circle cx="6" cy="12" r="3"/>
          <circle cx="18" cy="19" r="3"/>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
        {{ shareProfile}}
      </button>
      <button v-show="!isMyProfile" class="menu-item menu-item-danger" @click="$emit('reportPublication')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
          <line x1="4" y1="22" x2="4" y2="15"/>
        </svg>
        Report publication
      </button>
      <button v-show="!isMyProfile" class="menu-item menu-item-danger" @click="$emit('blockAccount')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
        </svg>
        Block
      </button>
      <button v-show="isMyProfile" class="menu-item" @click="$emit('blockedList')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <line x1="23" y1="9" x2="17" y2="9"/>
        </svg>
        Blocked accounts
      </button>
      <button v-show="isMyProfile" class="menu-item menu-item-danger" @click="$emit('deleteAccount')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"/>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
          <line x1="10" y1="11" x2="10" y2="17"/>
          <line x1="14" y1="11" x2="14" y2="17"/>
        </svg>
        Delete account
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropdownMenuButton',
  props: {
    isMyProfile: {
      type: Boolean,
      default: false
    },
    toShare:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      showMenu: false,
      shareProfile:"Partager profile"
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    async handleShareProfile (url='',title = '', text = '',k) {
      // Check if the Web Share API is supported
      if (navigator.share) {
        try {
          await navigator.share({
            title: title,
            text: text,
            url: url
          });
          return { success: true, method: 'share' };
        } catch (error) {
          // User cancelled the share or an error occurred
          if (error.name === 'AbortError') {
            console.log('Share cancelled by user');
            return { success: false, method: 'share', cancelled: true };
          }
          console.error('Error sharing:', error);
          // Fall through to clipboard as fallback
        }
      }
      
      // Fallback: Copy to clipboard
      try {
        await navigator.clipboard.writeText(url);
        k.shareProfile = "Lien copié !"
        setTimeout(() => k.shareProfile="Partager profile", 3000);
        return { success: true, method: 'clipboard' };
      } catch (error) {
        console.error('Failed to copy to clipboard:', error);
        return { success: false, method: 'clipboard', error };
      }
      //this.$emit('share-profile');
    },
    handleClickOutside(event) {
      // Check if click is outside the dropdown wrapper
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.showMenu = false;
      }
    }
  },
  mounted() {
    // Close menu when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped>
.dropdown-wrapper {
  z-index: 2;
  position: relative;
}

.dropdown-button {
  background: rgba(30, 41, 59, 0.8);
  color: #e0f7ff;
  border: 1px solid rgba(0, 212, 255, 0.2);
  padding: 14px 16px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dropdown-button svg {
  width: 20px;
  height: 20px;
}

.dropdown-button:hover {
  background: rgba(30, 41, 59, 1);
  border-color: rgba(0, 212, 255, 0.5);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: rgba(30, 41, 59, 0.95);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  z-index: 100;
  min-width: 200px;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.menu-item {
  width: 100%;
  background: transparent;
  border: none;
  color: #e0f7ff;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.menu-item:hover {
  background: rgba(0, 212, 255, 0.1);
}

.menu-item-danger {
  color: #ff6b6b;
}

.menu-item-danger:hover {
  background: rgba(255, 107, 107, 0.1);
}
</style>